module.exports = __webpack_public_path__ + "static/media/logo_regione.87148540.png";